import useProductResourceVisibility from '@/lib/hooks/use_product_resource_visibility'; 
export default function ProductNav({product}) {
const scrollToTop = () => {
    window.scrollTo({
      top: 0
    });
  };

  const {resourcesVisible, compatibleProductsVisible, inspirationVisible, collectionsVisible, similarProductsVisible, configuratorVisible} = useProductResourceVisibility(product)
  return (
    <div className="lexcms-product-nav">
      {resourcesVisible &&
      <a
        href="#lexcms-product-resources"
        className="lexcms-product-nav-item"
      >
        Resources
      </a>
      }
      {configuratorVisible &&
      <a
        href='#lexcms-configurator-section'
        className="lexcms-product-nav-item"
      >
        Configure
      </a>
      }
      {inspirationVisible &&
      <a
        href="#lexcms-product-inspiration"
        className="lexcms-product-nav-item"
      >
        Inspiration
      </a>
      }
      {similarProductsVisible &&
      <a
        href="#lexcms-product-similar-products"
        className="lexcms-product-nav-item"
      >
        Similar Products
      </a>
      }

      {compatibleProductsVisible &&
      <a
        href="#lexcms-product-similar-products"
        className="lexcms-product-nav-item"
      >
        Compatible Products
      </a>
      }

      {collectionsVisible &&
      <a
        href="#lexcms-product-collections"
        className="lexcms-product-nav-item"
      >
        Collections
      </a>
      }

     
      <button
        onClick={scrollToTop}
        className="lexcms-regular-button lexcms-product-nav-scroll-to-top"
      >
        Back to Top
      </button>
    </div>
  )

}
